import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  header: {
    alignItems: "center",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.background.paper,
    display: "flex",
    height: "48px",
    paddingLeft: theme.spacing(2),
    width: "100%",
  },
  sheet: {
    margin: theme.spacing(3, 0),
    padding: theme.spacing(8),
  },
});
